import { render, staticRenderFns } from "./OverviewV2.vue?vue&type=template&id=fe2d475e&scoped=true"
import script from "./OverviewV2.vue?vue&type=script&lang=js"
export * from "./OverviewV2.vue?vue&type=script&lang=js"
import style0 from "./OverviewV2.vue?vue&type=style&index=0&id=fe2d475e&prod&scoped=true&lang=css"
import style1 from "./OverviewV2.vue?vue&type=style&index=1&id=fe2d475e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2d475e",
  null
  
)

export default component.exports